import React from "react";

const HeadphoneLight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.164"
      height="19.019"
      viewBox="0 0 20.164 19.019"
    >
      <g id="Headphone-light" transform="translate(0.5 0.5)">
        <rect
          id="Rectangle_37"
          data-name="Rectangle 37"
          width="5"
          height="8"
          rx="2"
          transform="translate(14.164 10.019)"
          fill="none"
          stroke="#5fd068"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="5"
          height="8"
          rx="2"
          transform="translate(0.164 10.019)"
          fill="none"
          stroke="#5fd068"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M4,13v3.589"
          transform="translate(-4 -2.233)"
          fill="none"
          stroke="#5fd068"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Path_8"
          data-name="Path 8"
          d="M20,13v3.589"
          transform="translate(-0.86 -2.233)"
          fill="none"
          stroke="#5fd068"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Path_9"
          data-name="Path 9"
          d="M23.14,14.767a11.486,11.486,0,0,0-2.8-7.613A9.065,9.065,0,0,0,13.57,4,9.065,9.065,0,0,0,6.8,7.153,11.486,11.486,0,0,0,4,14.767"
          transform="translate(-4 -4)"
          fill="none"
          stroke="#5fd068"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default HeadphoneLight;
